<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <h3 class="headline mb-0">Facturas de Agremiados</h3>
        </v-card-title>
      </v-card>

      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">CPC y Fechas</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Seleccion de Facturas</v-stepper-step>
          <!-- <v-divider></v-divider>
          <v-stepper-step step="3">Descargar</v-stepper-step> -->
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="mb-5 elevation-0" height="200px">
              <v-form
                v-on:submit.prevent="validarCpc"
                ref="formcpc"
                v-model="validcpc"
                lazy-validation
              >
                <v-layout justify-center>
                  <v-flex xs12 sm6 md4 lg2 align-center justify-center>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="desde"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="desde"
                          label="Facturas Desde"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :rules="[(v) => !!v || 'Fecha desde es requerido']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :max="new Date().toISOString().substr(0, 7)"
                        v-model="desde"
                        type="month"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu2 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          flat
                          color="primary"
                          @click="$refs.menu2.save(desde)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg2 align-center justify-center>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="hasta"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="hasta"
                          label="Facturas Hasta"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          :rules="[(v) => !!v || 'Fecha hasta es requerido']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :max="new Date().toISOString().substr(0, 7)"
                        v-model="hasta"
                        type="month"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          flat
                          color="primary"
                          @click="$refs.menu.save(hasta)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md4 lg2 align-center justify-center>
                    <v-text-field
                      ref="cpc"
                      v-model="form.cpc"
                      prepend-icon="featured_video"
                      label="Ingresa el CPC"
                      :rules="[(v) => !!v || 'CPC es requerido']"
                      :error-messages="errCpc"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="loading" color="primary" @click="validarCpc">Siguiente</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="mb-5 elevation-0">
              <v-container grid-list-xl>
                <v-form
                  ref="formconceptos"
                  v-model="validfacturas"
                  lazy-validation
                  @submit.prevent=""
                >
                  <v-layout wrap row>
                    <v-flex xs12 sm2 md2></v-flex>
                    <v-flex xs12 sm6 md8 align-center justify-center>
                      <!-- data table concept ruaps -->
                      <v-data-table
                        :items="form.facturas"
                        class="elevation-0"
                        hide-actions
                        no-data-text=""
                        hide-headers
                      >
                        <template v-slot:items="props">
                          <tr>
                            <td>Factura #{{ props.item.id }}</td>
                            <td>{{ props.item.rif }} - {{ props.item.razon_social }}</td>
                            <td>{{ props.item.amount }} Bs</td>
                            <td class="text-xs-left">
                              <v-checkbox
                                color="primary"
                                v-model="form.facturas_old[props.index]"
                                :value="props.item.id"
                              ></v-checkbox>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>

                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card>
            <v-card-actions>
              <v-btn color="primary darken-1" @click="backToSearchCpc">Atras</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="setDataConcepts" v-print="'#printMe'">Descargar</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <!-- <v-stepper-content step="3">
            <p>paso 3</p>
          </v-stepper-content> -->
        </v-stepper-items>
      </v-stepper>
    </v-flex>
    <div v-if="arrFacturas">
        <PrintArrayFacturas :facturas="arrFacturas" v-show="print"/>
    </div>
  </v-layout>
</template>

<script>
import Form from "vform";
import axios from 'axios';
import VueNumericInput from "vue-numeric-input";
import PrintArrayFacturas from '~/components/factura/PrintArrayFacturas.vue';

export default {
  name: "facturas-view",

  components: {
    VueNumericInput,
    PrintArrayFacturas
  },

  mounted() {
    this.checkAuth();
  },

  data: () => ({
    print: false,
    checkbox: true,
    value: 1,
    e1: 0,
    taxesC: {},
    taxesCOLD: {},
    hasta: new Date().toISOString().substr(0, 7),
    desde: null,
    menu2: false,
    menu: false,
    loading: false,
    validcpc: false,
    validpago: false,
    validfacturas: false,
    errCpc: [],
    arrFacturas: [],
    wayToPay: [
      "TDD",
      "TDC",
      "EFECTIVO",
      "DIVISA",
      "TRANSFERENCIA",
      "PASARELA",
      "CRYPTOMONEDA",
      "PETRO",
    ],
    isUpdating: false,
    form: new Form({
      cpc: "",
      facturas: [],
      facturas_old: [],
    }),
  }),

  methods: {

    async validarCpc() {
        if (this.$refs.formcpc.validate()) {
            this.loading = true
            await axios.post('/api/administracion/atencion-agremiado/get-invoices', {
                cpc: this.form.cpc,
                f_desde: this.desde,
                f_hasta: this.hasta
            })
            .then(resp => {
              if (resp.data.length === 0) {
                this.e1 = 1
                this.$store.dispatch('responseMessage', {
                  type: 'error',
                  text: 'No se encontro informacion de facturas para este CPC'
                })
              }else {
                this.form.facturas = resp.data
                this.e1 = 2
              }
            })
            .catch(e => {
                console.log(e.response.data, 'error')
                this.loading = false
            });
            this.$nextTick(() => {
                this.loading = false
            })
        }
    },

    async checkAuth() {
      await this.$store.dispatch("fetchUser");
    },

    setDataConcepts() {
      this.loading = true

      let arrFacturasSelected = [];
      this.form.facturas.forEach((fact, ind) => {
        if (this.form.facturas_old[ind] == fact.id) {
            arrFacturasSelected.push(fact);
        }
      });
      this.arrFacturas = arrFacturasSelected;
      this.desde = null;
      this.hasta = new Date().toISOString().substr(0, 7);
      this.menu = false
      this.menu2 = false
      this.form = new Form({
        cpc: "",
        facturas: [],
        facturas_old: [],
      });
      this.$refs.formcpc.resetValidation();
      this.e1 = 1;
      this.$nextTick(() => {
          this.loading = false
      });
    },

    backToSearchCpc() {
      this.loading = true;
      this.desde = null;
      this.hasta = new Date().toISOString().substr(0, 7);
      this.menu = false
      this.menu2 = false
      this.form = new Form({
        cpc: "",
        facturas: [],
        facturas_old: [],
      });
      this.$refs.formcpc.resetValidation();
      this.e1 = 1;
      this.$nextTick(() => {
        this.loading = false;
      });
    },

  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/atencion/facturas.vue